import React, { useEffect, useRef, useState } from 'react';
import './StoreEmployee.css';
import Modal from '../../../Components/Modal/Modal';
import { useBusinessLogin } from '../../../hooks/auth/useBusinessLogin';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import { BiSearch, BiX, BiUserCheck, BiTrash, BiSend, BiGroup } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import CheckBox from '../../../Components/CheckBox/CheckBox';
import api from '../../../hooks/api';
import { useBEARER } from '../../../hooks/auth/useBEARER';
import TelegramSafeArea from '../../../Components/TelegramSafeArea';
import Swal from 'sweetalert2';

function StoreEmployee() {
    const { businessId, login } = useBusinessLogin();

    const [page, setPage] = useState(1);
    const [refreshCount, setRefreshCount] = useState(0);
    const [isOpenStatus, setIsOpenStatus] = useState(false);
    const [Dataset, setDataset] = useState([]);

    const [isListLoading, setIsListLoading] = useState(true);

    const [note, setNote] = useState("");
    const [position, setPosition] = useState("");

    const [userNationalId, setUserNationalId] = useState("");
    const [userExist, setUserExist] = useState(null);
    const [isSearch, setIsSearch] = useState(false);

    const [isChecking, setIsChecking] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [deletingId, setDeletingId] = useState(null);

    const sentinelRef = useRef();
    const [endPage, setEndPage] = useState(false);

    const [permissions, setPermissions] = useState([
        { id: 1, title: "مشخصات فروشگاه", checked: false },
        { id: 2, title: "تعریف کالا", checked: false },
        { id: 3, title: "سفارشات جدید", checked: false },
        { id: 4, title: "آماده سازی و بسته بندی", checked: false },
        { id: 5, title: "ارسال به پست", checked: false },
        { id: 6, title: "تحویل به پست", checked: false },
        { id: 7, title: "سفارشات تکمیل شده", checked: false },
        { id: 8, title: "فاکتورهای ابطال شده", checked: false },
        { id: 9, title: "اعلان مشتریان", checked: false },
    ]);

    const handleChange = (id) => {
        setPermissions(permissions.map(permission =>
            permission.id === id ? { ...permission, checked: !permission.checked } : permission
        ));
    };

    const fetchList = () => {
        if (!businessId || businessId <= 0) return;

        if (page === 1) setIsListLoading(true);

        const form = { business_id: businessId, rowCount: 10 };

        api.post(`collebration/list/admin?page=${page}`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                const resData = response.data;
                if (resData) {
                    const newData = Array.isArray(resData.data) ? resData.data : (resData.data?.data || []);

                    if (page === 1) {
                        setDataset(newData);
                    } else {
                        setDataset((prev) => {
                            const existingIds = new Set(prev.map(item => item.id));
                            const filteredNewData = newData.filter(item => !existingIds.has(item.id));
                            return [...prev, ...filteredNewData];
                        });
                    }

                    const lastPage = resData.data?.last_page;
                    if (lastPage && page < lastPage) {
                        setEndPage(false);
                    } else {
                        setEndPage(true);
                    }
                }
            })
            .catch((error) => console.error("Error fetching list:", error))
            .finally(() => {
                setIsListLoading(false);
            });
    };

    useEffect(() => {
        fetchList();
    }, [page, businessId, refreshCount]);

    useEffect(() => {
        if (isListLoading || endPage) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setPage((prevPage) => prevPage + 1);
            }
        }, { root: null, rootMargin: "0px", threshold: "1.0" });

        const sentinelNode = sentinelRef.current;
        if (sentinelNode) observer.observe(sentinelNode);

        return () => { if (sentinelNode) observer.unobserve(sentinelNode); };
    }, [isListLoading, endPage]);

    const eventToggleStatus = () => {
        setIsOpenStatus(!isOpenStatus);
    };

    const fn_userseach = () => {
        if (!userNationalId) return;
        setIsSearch(true);
        const form = {
            national_code: userNationalId
        };

        api.post(`user/search/text`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (response.data.success) {
                    setUserExist(response.data.data);
                    setPosition("");
                    setNote("");
                    setPermissions(permissions.map(p => ({ ...p, checked: false })));
                } else {
                    toast.error(response.data.message || "کاربری یافت نشد", { position: "top-center", theme: "colored", rtl: true });
                    setUserExist(null);
                }
            })
            .finally(() => setIsSearch(false));
    };

    const fn_CollebrationExist = () => {
        if (!userExist) return;
        setIsChecking(true);
        const form = {
            business_id: businessId,
            user_id: userExist["id"]
        };

        api.post(`collebration/exist/request`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (response.data.success) {
                    toast.error(response.data.message, { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
                } else {
                    setIsOpenStatus(true);
                }
            })
            .finally(() => setIsChecking(false));
    };

    const fn_save = () => {
        if (!userExist) {
            toast.error("همکار را جستجو نمائید!", { position: "top-right", theme: "colored", rtl: true, autoClose: 1000 });
            return;
        }

        const hasPermission = permissions.some(item => item.checked === true);
        if (!hasPermission) {
            toast.error("انتخاب حداقل یک سطح دسترسی الزامی است.", { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
            return;
        }

        if (!position || position.trim() === "") {
            toast.error("وارد کردن عنوان سمت شغلی الزامی است.", { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
            return;
        }

        if (!note || note.trim() === "") {
            toast.error("وارد کردن توضیحات تکمیلی الزامی است.", { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
            return;
        }

        setIsSubmitting(true);
        const form = {
            business_id: businessId,
            permission: JSON.stringify(permissions),
            national_id: userNationalId,
            user_id: userExist["id"],
            message: note,
            position: position,
        };

        api.post(`collebration/store`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.message, { position: "top-center", autoClose: 2000, theme: "colored", rtl: true });
                    setIsOpenStatus(false);
                    setUserExist(null);
                    setUserNationalId("");

                    setPage(1);
                    setEndPage(false);
                    setRefreshCount(prev => prev + 1);
                } else {
                    toast.error(response.data.message, { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
                }
            })
            .finally(() => setIsSubmitting(false));
    };

    const fn_delete = (id) => {
        setDeletingId(id);
        const form = {
            business_id: businessId,
            collebration_id: id,
        };

        api.post(`collebration/destroy/byAdmin`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.message, { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });

                    setPage(1);
                    setEndPage(false);
                    setRefreshCount(prev => prev + 1);
                } else {
                    toast.error(response.data.message, { position: "top-center", theme: "colored", rtl: true, autoClose: 1000 });
                }
            })
            .finally(() => setDeletingId(null));
    };

    const handleDeleteClick = (id) => {
        Swal.fire({
            title: 'پایان همکاری',
            html: '<span style="font-size: 15px; line-height: 1.8; color: #475569;">آیا از پایان دادن به همکاری با این کارمند اطمینان دارید؟<br/><strong style="color: #ef4444; font-size: 13.5px;">این عملیات قابل بازگشت نیست.</strong></span>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#f8fafc',
            confirmButtonText: 'بله، پایان همکاری',
            cancelButtonText: 'انصراف',
            reverseButtons: false,
            width: '320px',
            customClass: {
                popup: 'swal-pro-popup',
                title: 'vazir-font swal-pro-title',
                htmlContainer: 'vazir-font',
                actions: 'swal-pro-actions',
                confirmButton: 'vazir-font swal-pro-confirm',
                cancelButton: 'vazir-font swal-pro-cancel',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                fn_delete(id);
            }
        });
    };

    const getStatusTheme = (statusId) => {
        switch (parseInt(statusId)) {
            case 23: return { label: 'در انتظار تایید', class: 'theme-pending' };
            case 24: return { label: 'همکار فعال', class: 'theme-active' };
            case 25: return { label: 'رد شده', class: 'theme-declined' };
            case 26: return { label: 'اتمام همکاری', class: 'theme-ended' };
            default: return { label: 'نامشخص', class: 'theme-default' };
        }
    };

    return (
        <>
            <div className='store-employee'>
                <div className="store-employee-search">
                    <div className="search-box-wrapper">
                        <input
                            type='text'
                            value={userNationalId}
                            placeholder='کد ملی همکار را وارد کنید...'
                            onChange={(e) => setUserNationalId(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && fn_userseach()}
                            disabled={isSearch}
                        />
                        <div className="search-icon-btn" onClick={fn_userseach}>
                            {isSearch ? (
                                <ReactLoading type="spin" color="#3b82f6" height={22} width={22} />
                            ) : (
                                <BiSearch size={'25px'} />
                            )}
                        </div>
                        {userNationalId && !isSearch && (
                            <div className='clear-search-btn' onClick={() => { setUserNationalId(""); setUserExist(null); }}>
                                <IoClose size={16} />
                            </div>
                        )}
                    </div>
                </div>

                {login && (
                    <div className='store-employee-list'>
                        {userExist && (
                            <div className='store-employee-list-item-search'>
                                <span className="new-employee-badge">کارمند جدید</span>
                                <div className='close-search' onClick={() => setUserExist(null)}>
                                    <BiX size={18} />
                                </div>
                                <div className='search-result-row'>
                                    <span>{`${userExist["name"]} ${userExist["family"]}`}</span>
                                    <span>{userExist["national_id"]}</span>
                                </div>
                                <div className="employee-card-footer" style={{ padding: '5px 0 0 0', border: 'none' }}>
                                    <button
                                        className="employee-action-btn btn-request"
                                        onClick={fn_CollebrationExist}
                                        disabled={isChecking}
                                    >
                                        {isChecking ? (
                                            <ReactLoading type="spin" color="#ffffff" height={20} width={20} />
                                        ) : (
                                            <>
                                                <BiUserCheck size={18} />
                                                تنظیم دسترسی و ارسال درخواست
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}

                        {isListLoading ? (
                            Array.from({ length: 4 }).map((_, index) => (
                                <div className="employee-card skeleton-card" key={`skeleton-${index}`}>
                                    <div className="employee-card-header">
                                        <div className="header-info" style={{ width: '60%' }}>
                                            <div className="skeleton-bg" style={{ width: '70%', height: '14px', borderRadius: '4px', marginBottom: '8px' }}></div>
                                            <div className="skeleton-bg" style={{ width: '40%', height: '10px', borderRadius: '4px' }}></div>
                                        </div>
                                        <div className="skeleton-bg" style={{ width: '70px', height: '22px', borderRadius: '8px' }}></div>
                                    </div>
                                    <div className="employee-card-body">
                                        <div className="skeleton-bg" style={{ width: '40%', height: '12px', borderRadius: '4px', marginBottom: '10px' }}></div>
                                        <div className="skeleton-bg" style={{ width: '80%', height: '12px', borderRadius: '4px', marginBottom: '10px' }}></div>
                                        <div className="skeleton-bg" style={{ width: '90%', height: '12px', borderRadius: '4px' }}></div>
                                    </div>
                                    <div className="employee-card-footer">
                                        <div className="skeleton-bg" style={{ width: '100%', height: '42px', borderRadius: '12px' }}></div>
                                    </div>
                                </div>
                            ))
                        ) : Dataset && Dataset.length > 0 ? (
                            <>
                                {Dataset.map(item => {
                                    const theme = getStatusTheme(item.status_id);
                                    return (
                                        <div className={`employee-card ${theme.class}`} key={item.id}>
                                            <div className='employee-card-header'>
                                                <div className="header-info">
                                                    <span className='employee-name'>
                                                        {`${item.collebrate?.name || "بدون نام"} ${item.collebrate?.family || ""}`}
                                                    </span>
                                                    <span className='employee-mobile'>
                                                        {item.collebrate?.mobile}
                                                    </span>
                                                </div>
                                                <div className="status-tag">
                                                    {item.status?.message || theme.label}
                                                </div>
                                            </div>

                                            <div className='employee-card-body'>
                                                <div className='info-row'>
                                                    <span className='info-label'>کد ملی:</span>
                                                    <span className='info-value'>{item.collebrate?.national_code}</span>
                                                </div>
                                                <div className='info-row'>
                                                    <span className='info-label'>سمت:</span>
                                                    <span className='info-value'>{(item.position || "تعیین نشده").substring(0, 50)}</span>
                                                </div>
                                                {item.message && (
                                                    <div className='info-row'>
                                                        <span className='info-label'>پیام:</span>
                                                        <span className='info-value'>{item.message.substring(0, 70)}...</span>
                                                    </div>
                                                )}
                                            </div>

                                            {![25, 26].includes(parseInt(item.status_id)) && (
                                                <div className="employee-card-footer">
                                                    <button
                                                        className="employee-action-btn btn-terminate"
                                                        onClick={() => handleDeleteClick(item.id)}
                                                        disabled={deletingId === item.id}
                                                    >
                                                        {deletingId === item.id ? (
                                                            <ReactLoading type="spin" color="#ffffff" height={20} width={20} />
                                                        ) : (
                                                            <>
                                                                <BiTrash size={18} />
                                                                پایان همکاری
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}

                                <div id="loading_page" ref={sentinelRef} style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                                    {!endPage && page > 1 && <ReactLoading type={"bubbles"} color={"#3b82f6"} height={40} width={40} />}
                                </div>
                            </>
                        ) : (
                            /* --- پیام خالی بودن لیست همکاران --- */
                            <div className="empty-employee-list">
                                <div className="empty-employee-icon">
                                    <BiGroup size={48} />
                                </div>
                                <h3 className="empty-employee-title">همکاری یافت نشد</h3>
                                <p className="empty-employee-desc">
                                    هنوز کارمندی برای این فروشگاه ثبت نشده است. با جستجوی کد ملی همکار در کادر بالا، می‌توانید همکار جدید اضافه کنید.
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* مودال تعیین سطح دسترسی */}
            <Modal eventToggle={eventToggleStatus} isOpen={isOpenStatus} locked={true} fullscreen={true}>
                <div className="permissions-employee">

                    {/* ---------------- TelegramSafeArea ---------------- */}
                    <TelegramSafeArea style={{ background: "#f8fafc", color: "#000" }}>
                        <div
                            className="safe-area-title"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1.3',
                                padding: '5px 0'
                            }}
                        >
                            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>سبد 1</span>
                            <span style={{ fontSize: '12px', opacity: 0.85 }}>فروشگاه آنلاین</span>
                        </div>
                    </TelegramSafeArea>
                    {/* -------------------------------------------------- */}

                    <div className="permissions-header">
                        <div className="title">فرم درخواست همکاری</div>
                        <div className="close-btn" onClick={() => !isSubmitting && eventToggleStatus()}>
                            <BiX size={24} />
                        </div>
                    </div>

                    <div className='permissions-body' style={{ paddingBottom: 'calc(60px + env(safe-area-inset-bottom))' }}>

                        {/* 1. فیلد سمت شغلی */}
                        <div className="input-group">
                            <label>سمت شغلی همکار (الزامی):</label>
                            <textarea
                                placeholder='مثلا: حسابدار، انباردار و...'
                                rows="1"
                                value={position}
                                onChange={(e) => setPosition(e.target.value)}
                                disabled={isSubmitting}
                            ></textarea>
                        </div>

                        {/* 2. تعیین سطح دسترسی‌ها */}
                        <div>
                            <div className='section-title'>تعیین سطح دسترسی‌ها</div>
                            <div className="permissions-list">
                                {permissions.map(permission => (
                                    <div
                                        className={`permission-item ${permission.checked ? 'selected' : ''}`}
                                        key={permission.id}
                                    >
                                        <span>{permission.title}</span>
                                        <CheckBox
                                            label={permission.label}
                                            checked={permission.checked}
                                            onChange={() => !isSubmitting && handleChange(permission.id)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 3. توضیحات تکمیلی */}
                        <div className="input-group">
                            <label>توضیحات تکمیلی (الزامی):</label>
                            <textarea
                                placeholder='پیامی برای همکار بنویسید...'
                                rows="3"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                disabled={isSubmitting}
                            ></textarea>
                        </div>

                        {/* 4. دکمه‌ها به اینجا منتقل شدند تا با محتوا اسکرول شوند */}
                        <div className="permissions-footer scrollable-footer">
                            <button className="modal-btn submit" onClick={fn_save} disabled={isSubmitting}>
                                {isSubmitting ? (
                                    <ReactLoading type="spin" color="#ffffff" height={22} width={22} />
                                ) : (
                                    <>
                                        <BiSend size={18} style={{ marginLeft: '8px' }} />
                                        ثبت و ارسال درخواست
                                    </>
                                )}
                            </button>
                            <button className="modal-btn cancel" onClick={eventToggleStatus} disabled={isSubmitting}>
                                انصراف
                            </button>
                        </div>

                    </div>
                </div>
            </Modal>
        </>
    );
}

export default StoreEmployee;
